import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";
import {connect} from "react-redux";

import * as itemTypes from "../../../constants/itemTypes";
import * as settings from "../../../constants/settings";
import * as resources from "../../../constants/resources";
import * as formatHelper from "../../../helpers/formatHelper";
import * as getterHelper from "../../../helpers/getterHelper";
import * as modelHelper from "../../../helpers/modelHelper";
import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as barcodeActions from "../../../actions/barcodeActions";
import * as customersActions from "../../../actions/customersActions";
import * as rccActions from "../../../actions/rccActions";

import imgBarcode from "../../../resources/img/svgicons/barcode.svg";
import imgCustomers from "../../../resources/img/svgicons/customers.svg";
import imgBarcodeReset from "../../../resources/img/svgicons/barcode-reset.svg";
import imgRefill from "../../../resources/img/svgicons/over-fill.svg";

import Button from "../generic/Button";
import Modal from "../generic/Modal";
import CancelButton from "../generic/CancelButton";

class BarcodeTestModal extends Component {
    selectFormula = (color, product, fandeck, base) => {
        this.props.dispatchSelectFormula(color, product, fandeck, base);
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseBarcodeTestModalAction();
    };

    handleResetButtonClick = () => {
        this.props.dispatchBarcodeResetAction();
    };

    handleManualScanButtonClick = () => {
        this.props.dispatchShowManualScanAction(true);
    };

    handleOpenCustomerButtonClick = () => {
        this.props.dispatchOpenCustomerTabAction(this.props.item.id);
    };

    handleRefillButtonClick = () => {
        let canister = getterHelper.getCanisterByColorantPackage(this.props.item.colorantName, this.props.canisterList);

        if (canister !== null) {
            this.props.dispatchStartRefillAction(canister.id);
        }
    };

    handleOpenColorButtonClick = () => {
        if (this.props.itemType === itemTypes.COLOR_IN_FANDECK) {
            this.selectFormula(this.props.item.color, null, this.props.item.fandeck, null);
        }
        if (this.props.itemType === itemTypes.COLOR) {
            this.selectFormula(this.props.item, null, null, null);
        }
    };

    getResetButton = () => {
        if (this.props.barcode === "") {
            return "";
        }

        return (
            <Button
                label={<Translate value="general.reset" />}
                svgBefore={imgBarcodeReset}
                onClick={this.handleResetButtonClick}
            />
        );
    };

    getManualScanButton = () => {
        if (this.props.barcode !== "") {
            return "";
        }

        return (
            <Button
                label={<Translate value="customRedlikeMachine.manualScan" />}
                svgBefore={imgBarcode}
                onClick={this.handleManualScanButtonClick}
            />
        );
    };

    getBarcodeItemType = () => {
        switch (this.props.itemType) {
            case itemTypes.BASE_IN_PRODUCT_PACKAGE:
                return <Translate value="general.baseInProductPackage" />;
            case itemTypes.COLORANT_PACKAGE:
                return <Translate value="general.colorantPackage" />;
            case itemTypes.COLOR_IN_FANDECK:
            case itemTypes.COLOR:
                return <Translate value="general.color" />;
            case itemTypes.COLORANT_BATCH_NUMBER:
                return <Translate value="general.colorantBatchNumber" />;
            case itemTypes.CUSTOMER:
                return <Translate value="general.customer" />;
            case itemTypes.USER:
                return <Translate value="general.user" />;
            case itemTypes.FORMULA_COMBINATION:
            case itemTypes.FORMULA_COMBINATION_FOR_BIPP:
                return <Translate value="general.formula" />;
            case -2:
                return <Translate value="general.canister" />;
            default:
                return "";
        }
    };

    getScanResults = () => {
        if (this.props.barcode === "") {
            return (
                <div className="col-12 alert alert-info">
                    <Translate value="testBarcode.pleaseScanBarcode" />
                    ...
                </div>
            );
        }

        if (this.props.itemType === -1) {
            return (
                <div className="col-12 alert alert-warning">
                    <Translate value="testBarcode.noItemAssigned" code={this.props.barcode} />
                </div>
            );
        }

        return <div className="col-12 alert alert-success">{this.props.barcode}</div>;
    };

    getItemType = () => {
        if (this.props.itemType === null || this.props.itemType === -1) {
            return "";
        }

        return (
            <div className="col-12 color-primary">
                {this.getBarcodeItemType()} {this.props.barcode}
            </div>
        );
    };

    getNameClass = (item) => {
        if (item !== undefined && item !== null && item.name === "") {
            return "col-8 text-gray";
        }

        return "col-8";
    };

    getColorantNameClass = (item) => {
        if (item !== undefined && item !== null && item.colorantName === "") {
            return "col-8 text-gray";
        }

        return "col-8";
    };

    getColorNameClass = (item) => {
        if (item !== undefined && item !== null && item.displayName === "") {
            return "col-8 text-gray";
        }

        return "col-8";
    };

    getPackagePreviewImage = () => {
        let img = window.imageStore.getBarcodeTestImage(itemTypes.BASE_IN_PRODUCT_PACKAGE);

        if (img === null) {
            return null;
        }

        return (
            <div className="col-12" key={this.props.item.package.name + "_div"}>
                <img
                    key={this.props.item.package.name}
                    alt={this.props.item.package.name}
                    src={"data:" + img.type + ";base64," + img.img}
                    style={{maxHeight: 180}}
                />
            </div>
        );
    };

    getPackageColorantPreviewImage = () => {
        let img = window.imageStore.getBarcodeTestImage(itemTypes.COLORANT_PACKAGE);

        if (img === null) {
            return null;
        }

        return (
            <div className="col-12" key={this.props.item.colorantName + "_div"}>
                <img
                    key={this.props.item.colorantName}
                    alt={this.props.item.colorantName}
                    src={"data:" + img.type + ";base64," + img.img}
                    style={{maxHeight: 180}}
                />
            </div>
        );
    };

    getItemText = (item) => {
        if (item === "" || item === null) {
            return "-";
        }

        return item;
    };

    getItemActionsButtons = () => {
        if (this.props.gammaSoftware) {
            return null;
        }

        if (this.props.item === null) {
            return null;
        }

        let buttons = [];

        if (this.props.itemType === itemTypes.CUSTOMER) {
            buttons.push(
                <Button
                    key="open-customer-btn"
                    label={<Translate value="general.open" />}
                    svgBefore={imgCustomers}
                    onClick={this.handleOpenCustomerButtonClick}
                />
            );
        }

        if (
            this.props.itemType === itemTypes.COLORANT_PACKAGE &&
            this.props.loggedUser.canEdit(resources.FUNCTION_TRIGGER_REFILL_DIALOG) &&
            getterHelper.getCanisterByColorantPackage(this.props.item.colorantName, this.props.canisterList) !== null
        ) {
            buttons.push(
                <Button
                    key="open-refill-btn"
                    label={<Translate value="general.refill" />}
                    svgBefore={imgRefill}
                    onClick={this.handleRefillButtonClick}
                />
            );
        }

        if (this.props.itemType === itemTypes.COLOR || this.props.itemType === itemTypes.COLOR_IN_FANDECK) {
            buttons.push(
                <Button
                    key="handleOpenColorButtonClickButton"
                    label={<Translate value="general.open" />}
                    onClick={this.handleOpenColorButtonClick}
                />
            );
        }

        return buttons;
    };

    getChannels = () => {
        let channels = "";

        for (let channel of this.props.item.channels) {
            channels += channel + ", ";
        }

        return channels.substring(0, channels.length - 2);
    };

    getInfoRow = (label, info) => {
        return (
            <React.Fragment>
                <div className="col-4">{label}</div>
                {info}
            </React.Fragment>
        );
    };

    getNameInfoRow = (label, info) => {
        return (
            <React.Fragment>
                <div className="col-4">{label}</div>
                <div className={this.getNameClass(info)}>
                    {info === null ? "" : info.name === "" ? translate("general.withoutName") : info.name}
                </div>
            </React.Fragment>
        );
    };

    getDisplayNameInfoRow = (label, info) => {
        return (
            <React.Fragment>
                <div className="col-4">{label}</div>
                <div className={this.getNameClass(info)}>
                    {info === null ? "" : info.displayName === "" ? translate("general.withoutName") : info.displayName}
                </div>
            </React.Fragment>
        );
    };

    getColorPreviewRow = (rgb) => {
        return (
            <React.Fragment>
                <div className="col-12">
                    <Translate value="general.colorPreview" />
                </div>
                <div
                    className="border-black border-radius-5"
                    style={{
                        backgroundColor: rgb,
                        height: "38px",
                        width: "100%"
                    }}
                />
            </React.Fragment>
        );
    };

    getItemInfo = () => {
        if (this.props.itemType === itemTypes.COLORANT_BATCH_NUMBER) {
            const barcodeSplit = this.props.barcode.split(";");
            return (
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">{translate("general.colorant")}:</div>
                    <div className="col-8">{barcodeSplit[0]}</div>
                    <div className="col-4">{translate("general.colorantBatchNumber")}:</div>
                    <div className="col-8">{barcodeSplit[1]}</div>
                    <div className="col-4">{translate("general.created")}:</div>
                    <div className="col-8">{barcodeSplit[2]}</div>
                </div>
            );
        }

        if (this.props.itemType === null || this.props.itemType === -1 || this.props.item === null) {
            return null;
        }

        if (this.props.itemType === itemTypes.BASE_IN_PRODUCT_PACKAGE) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getNameInfoRow(<Translate value="general.product" />, this.props.item.product)}
                    {this.getNameInfoRow(<Translate value="general.base" />, this.props.item.base)}
                    {this.getNameInfoRow(<Translate value="general.package" />, this.props.item.package)}
                    {this.getInfoRow(
                        <Translate value="general.filling" />,
                        <div className="col-8">{this.props.item.filling}</div>
                    )}
                    {this.getPackagePreviewImage()}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.COLOR_IN_FANDECK) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getNameInfoRow(<Translate value="general.fandeck" />, this.props.item.fandeck)}
                    {this.getNameInfoRow(<Translate value="general.color" />, this.props.item.color)}
                    {this.getInfoRow(
                        <Translate value="general.color" />,
                        <div className={this.getNameClass(this.props.item.color)}>
                            {this.props.item.color === null
                                ? ""
                                : this.props.item.color.rgb === ""
                                  ? translate("general.withoutName")
                                  : this.props.item.color.rgb}
                        </div>
                    )}
                    {this.getColorPreviewRow(this.props.item.color.rgb)}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.COLORANT_PACKAGE) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getNameInfoRow(<Translate value="general.nameTitle" />, this.props.item)}
                    {this.getInfoRow(
                        <Translate value="general.colorant" />,
                        <div className={this.getColorantNameClass(this.props.item)}>
                            {this.props.item.colorantName === ""
                                ? translate("general.withoutName")
                                : this.props.item.colorantName}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.nominalAmount" />,
                        <div className="col-8">{this.props.item.nominalAmount}</div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.filling" />,
                        <div className="col-8">{this.props.item.filling}</div>
                    )}
                    {this.getPackageColorantPreviewImage()}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.CUSTOMER) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getNameInfoRow(<Translate value="general.name" />, this.props.item)}
                    {this.getInfoRow(
                        <Translate value="general.country" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.country)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.city" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.city)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.street" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.street)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.zipCode" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.zipCode)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.email" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.email)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.phone" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.phone)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.margin" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.marginName)}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="customersTab.identificationNumber" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.getItemText(this.props.item.identification)}
                        </div>
                    )}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.COLOR) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getInfoRow(
                        <Translate value="general.nameTitle" />,
                        <div className={this.getColorNameClass(this.props.item)}>
                            {this.props.item.displayName === ""
                                ? translate("general.withoutName")
                                : this.props.item.displayName}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.color" />,
                        <div className="col-8">
                            <div>{this.props.item.rgb}</div>
                        </div>
                    )}
                    {this.getColorPreviewRow(this.props.item.rgb)}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.USER) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getInfoRow(
                        <Translate value="general.name" />,
                        <div className="col-8">{this.props.item.login}</div>
                    )}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.FORMULA_COMBINATION) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getDisplayNameInfoRow(<Translate value="general.product" />, this.props.item.product)}
                    {this.getDisplayNameInfoRow(<Translate value="general.fandeck" />, this.props.item.fandeck)}
                    {this.getDisplayNameInfoRow(<Translate value="general.color" />, this.props.item.color)}
                    {this.getDisplayNameInfoRow(<Translate value="general.base" />, this.props.item.base)}
                </div>
            );
        }

        if (this.props.itemType === itemTypes.FORMULA_COMBINATION_FOR_BIPP) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getDisplayNameInfoRow(<Translate value="general.product" />, this.props.item.product)}
                    {this.getDisplayNameInfoRow(<Translate value="general.fandeck" />, this.props.item.fandeck)}
                    {this.getDisplayNameInfoRow(<Translate value="general.color" />, this.props.item.color)}
                    {this.getDisplayNameInfoRow(<Translate value="general.base" />, this.props.item.base)}
                    {this.getInfoRow(
                        <Translate value="general.package" />,
                        <div className={this.getColorNameClass(this.props.item.bipp)}>
                            {this.props.item.bipp === null
                                ? ""
                                : this.props.item.bipp.displayName === ""
                                  ? translate("general.withoutName")
                                  : this.props.item.bipp.displayName}
                        </div>
                    )}
                </div>
            );
        }

        if (this.props.itemType === -2) {
            return (
                <div className="col-12 flex flex-wrap">
                    {this.getDisplayNameInfoRow(<Translate value="general.name" />, this.props.item?.colorant)}
                    {this.getInfoRow(
                        <Translate value="canistersTab.currentLevel" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.props.item === null
                                ? ""
                                : this.props.item.currentLevelMl === null
                                  ? translate("general.withoutName")
                                  : this.props.item.currentLevelMl + " " + settings.UNIT_ML}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.capacity" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.props.item === null
                                ? ""
                                : this.props.item.capacityMl === null
                                  ? translate("general.withoutName")
                                  : this.props.item.capacityMl + " " + settings.UNIT_ML}
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.fillState" />,
                        <div className={this.getNameClass(this.props.item)}>
                            {this.props.item === null
                                ? ""
                                : this.props.item.currentLevelMl === null &&
                                    (this.props.item.capacityMl === null || this.props.item.capacity === 0)
                                  ? translate("general.withoutName")
                                  : formatHelper.convertDecimalToPercent(
                                        this.props.item.currentLevelMl / this.props.item.capacityMl
                                    )}
                            %
                        </div>
                    )}
                    {this.getInfoRow(
                        <Translate value="general.channels" />,
                        <div className={this.getColorNameClass(this.props.item)}>
                            {this.props.item === null
                                ? ""
                                : this.props.item.channels === ""
                                  ? translate("general.withoutName")
                                  : this.getChannels()}
                        </div>
                    )}
                </div>
            );
        }

        return "";
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getScanResults()}
                {this.getItemType()}
                {this.getItemInfo()}
            </React.Fragment>,
            "flex flex-column"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex flex-gap-10px">{this.getItemActionsButtons()}</div>
                <div className="flex margin-left-auto flex-gap-10px">
                    {this.getResetButton()}
                    {this.getManualScanButton()}
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>,
            "flex"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                header={modelHelper.buildModalSection(<Translate value="testBarcode.testBarcodes" />)}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        barcode: store.barcode.barcode,
        itemType: store.barcode.itemType,
        item: store.barcode.item,
        gammaSoftware: store.module.gammaSoftware,
        imageStore: store.navigation.imageStore,
        canisterList: store.rcc.canisterList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseBarcodeTestModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.BARCODE_TEST_MODAL));
            dispatch(barcodeActions.resetBarcode());
        },
        dispatchBarcodeResetAction: () => {
            dispatch(barcodeActions.resetBarcode());
        },
        dispatchShowManualScanAction: (show) => {
            dispatch(barcodeActions.showManualScan(show));
        },
        dispatchOpenCustomerTabAction: (customerId) => {
            dispatch(navigationActions.closeModal(componentTypes.BARCODE_TEST_MODAL));
            dispatch(customersActions.openCustomerInNewTab(customerId));
        },
        dispatchStartRefillAction: (index) => {
            dispatch(navigationActions.closeModal(componentTypes.BARCODE_TEST_MODAL));
            dispatch(rccActions.startCanisterRefill(index));
        },
        dispatchSelectFormula: (color, product, fandeck, base) => {
            dispatch(navigationActions.selectFormula(color, product, fandeck, base));
            dispatch(navigationActions.closeModal(componentTypes.BARCODE_TEST_MODAL));
        }
    };
};

export default BarcodeTestModal = connect(mapStoreToProps, mapDispatchToProps)(BarcodeTestModal);
